import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { motion } from "framer-motion";
import { animationValues, transitionValues } from "../../utils/pageTransitions";
import AllTransactions from "./transactions/allTransactions";
import SuccessfulTransactions from "./transactions/successfulTransactions";
import FailedTransactions from "./transactions/failedTransactions";
import PendingTransactions from "./transactions/pendingTransactions";

function Transactions() {
  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="container-fluid suppliers">
        <div className="">
          <h2 className="sectionText--big textIsBold">Transactions</h2>
        </div>

        <Tabs className="pt-3">
          <TabList className="alignOnly sectionText p-0">
            <Tab className="tabHead">All</Tab>
            <Tab className="tabHead">Successfull</Tab>
            {/* <Tab className="tabHead">Failed</Tab> */}
            <Tab className="tabHead">Failed</Tab>
          </TabList>

          <TabPanel>
            <AllTransactions type="all" />
          </TabPanel>
          <TabPanel>
            <AllTransactions type="success" />
            {/* <SuccessfulTransactions/> */}
          </TabPanel>
          {/* <TabPanel> */}
            {/* <AllTransactions type="failed" /> */}
            {/* <FailedTransactions/> */}
          {/* </TabPanel> */}
          <TabPanel>
            <AllTransactions type="pending" />
            {/* <PendingTransactions/> */}
          </TabPanel>
        </Tabs>
      </div>
    </motion.div>
  );
}

export default Transactions;
